var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6129 11.7625L0.177419 6.44327C0.112903 6.37995 0.0673118 6.31135 0.0406452 6.23747C0.0135484 6.16359 0 6.08443 0 6C0 5.91557 0.0135484 5.83641 0.0406452 5.76253C0.0673118 5.68865 0.112903 5.62005 0.177419 5.55673L5.6129 0.221636C5.76344 0.0738786 5.95161 0 6.17742 0C6.40323 0 6.59677 0.0791557 6.75806 0.237467C6.91935 0.395778 7 0.580475 7 0.791557C7 1.00264 6.91935 1.18734 6.75806 1.34565L2.01613 6L6.75806 10.6544C6.9086 10.8021 6.98387 10.9841 6.98387 11.2002C6.98387 11.4168 6.90323 11.6042 6.74194 11.7625C6.58065 11.9208 6.39247 12 6.17742 12C5.96237 12 5.77419 11.9208 5.6129 11.7625Z",
    fill: "#637381"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.f55ce1af5f4b18450de100e06fecd42b.svg";
export { ForwardRef as ReactComponent };